/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The LogControllerDtoPilotSkillChangeLogListPilotSkillChangeLogData model module.
 * @module model/LogControllerDtoPilotSkillChangeLogListPilotSkillChangeLogData
 * @version 1.0
 */
class LogControllerDtoPilotSkillChangeLogListPilotSkillChangeLogData {
    /**
     * Constructs a new <code>LogControllerDtoPilotSkillChangeLogListPilotSkillChangeLogData</code>.
     * @alias module:model/LogControllerDtoPilotSkillChangeLogListPilotSkillChangeLogData
     */
    constructor() { 
        
        LogControllerDtoPilotSkillChangeLogListPilotSkillChangeLogData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>LogControllerDtoPilotSkillChangeLogListPilotSkillChangeLogData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/LogControllerDtoPilotSkillChangeLogListPilotSkillChangeLogData} obj Optional instance to populate.
     * @return {module:model/LogControllerDtoPilotSkillChangeLogListPilotSkillChangeLogData} The populated <code>LogControllerDtoPilotSkillChangeLogListPilotSkillChangeLogData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new LogControllerDtoPilotSkillChangeLogListPilotSkillChangeLogData();

            if (data.hasOwnProperty('logNo')) {
                obj['logNo'] = ApiClient.convertToType(data['logNo'], 'Number');
            }
            if (data.hasOwnProperty('accountNo')) {
                obj['accountNo'] = ApiClient.convertToType(data['accountNo'], 'Number');
            }
            if (data.hasOwnProperty('nftUid')) {
                obj['nftUid'] = ApiClient.convertToType(data['nftUid'], 'Number');
            }
            if (data.hasOwnProperty('skillNumber')) {
                obj['skillNumber'] = ApiClient.convertToType(data['skillNumber'], 'Number');
            }
            if (data.hasOwnProperty('beforeAmount')) {
                obj['beforeAmount'] = ApiClient.convertToType(data['beforeAmount'], 'Number');
            }
            if (data.hasOwnProperty('afterAmount')) {
                obj['afterAmount'] = ApiClient.convertToType(data['afterAmount'], 'Number');
            }
            if (data.hasOwnProperty('type')) {
                obj['type'] = ApiClient.convertToType(data['type'], 'String');
            }
            if (data.hasOwnProperty('walletTransactionNo')) {
                obj['walletTransactionNo'] = ApiClient.convertToType(data['walletTransactionNo'], 'String');
            }
            if (data.hasOwnProperty('itemTransactionNo')) {
                obj['itemTransactionNo'] = ApiClient.convertToType(data['itemTransactionNo'], 'String');
            }
            if (data.hasOwnProperty('createdAt')) {
                obj['createdAt'] = ApiClient.convertToType(data['createdAt'], 'Date');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>LogControllerDtoPilotSkillChangeLogListPilotSkillChangeLogData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>LogControllerDtoPilotSkillChangeLogListPilotSkillChangeLogData</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['type'] && !(typeof data['type'] === 'string' || data['type'] instanceof String)) {
            throw new Error("Expected the field `type` to be a primitive type in the JSON string but got " + data['type']);
        }
        // ensure the json data is a string
        if (data['walletTransactionNo'] && !(typeof data['walletTransactionNo'] === 'string' || data['walletTransactionNo'] instanceof String)) {
            throw new Error("Expected the field `walletTransactionNo` to be a primitive type in the JSON string but got " + data['walletTransactionNo']);
        }
        // ensure the json data is a string
        if (data['itemTransactionNo'] && !(typeof data['itemTransactionNo'] === 'string' || data['itemTransactionNo'] instanceof String)) {
            throw new Error("Expected the field `itemTransactionNo` to be a primitive type in the JSON string but got " + data['itemTransactionNo']);
        }

        return true;
    }


}



/**
 * @member {Number} logNo
 */
LogControllerDtoPilotSkillChangeLogListPilotSkillChangeLogData.prototype['logNo'] = undefined;

/**
 * @member {Number} accountNo
 */
LogControllerDtoPilotSkillChangeLogListPilotSkillChangeLogData.prototype['accountNo'] = undefined;

/**
 * @member {Number} nftUid
 */
LogControllerDtoPilotSkillChangeLogListPilotSkillChangeLogData.prototype['nftUid'] = undefined;

/**
 * @member {Number} skillNumber
 */
LogControllerDtoPilotSkillChangeLogListPilotSkillChangeLogData.prototype['skillNumber'] = undefined;

/**
 * @member {Number} beforeAmount
 */
LogControllerDtoPilotSkillChangeLogListPilotSkillChangeLogData.prototype['beforeAmount'] = undefined;

/**
 * @member {Number} afterAmount
 */
LogControllerDtoPilotSkillChangeLogListPilotSkillChangeLogData.prototype['afterAmount'] = undefined;

/**
 * @member {String} type
 */
LogControllerDtoPilotSkillChangeLogListPilotSkillChangeLogData.prototype['type'] = undefined;

/**
 * @member {String} walletTransactionNo
 */
LogControllerDtoPilotSkillChangeLogListPilotSkillChangeLogData.prototype['walletTransactionNo'] = undefined;

/**
 * @member {String} itemTransactionNo
 */
LogControllerDtoPilotSkillChangeLogListPilotSkillChangeLogData.prototype['itemTransactionNo'] = undefined;

/**
 * @member {Date} createdAt
 */
LogControllerDtoPilotSkillChangeLogListPilotSkillChangeLogData.prototype['createdAt'] = undefined;






export default LogControllerDtoPilotSkillChangeLogListPilotSkillChangeLogData;

